import React, { useEffect, useState } from "react";
import "./ProfileHeader.css";
import Follow_icon from "../../assets/images/follow_icon.svg";
import { useUser } from "../../Context/UserContext";
import { callApi } from "../../utils/apiService";
import { videoCreatorEndPoint } from "../../Constants/constants";

const ProfileHeader = () => {
  const [creatorData, setCreatorData] = useState(null);
  const [loading, setLoading] = useState(false);

  const { user } = useUser();

  const fetchCreatorData = async () => {
    if (!user?.id) return;

    try {
      setLoading(true);

      const response = await callApi(
        `${videoCreatorEndPoint}creatorData/${user?.id}`,
        "GET",
      );

      if (response?.status) {
        setCreatorData(response.data);
      }
    } catch (error) {
      console.error("Creator Details API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCreatorData();
  }, [user?.id]);

  const Avatar = () => {
    if (creatorData?.profileUrl) {
      return (
        <img
          src={creatorData?.profileUrl}
          alt={creatorData?.fullName}
          className="w-full h-full object-cover"
        />
      );
    }
    return (
      <div className="w-full h-full object-cover">
        {creatorData?.fullName
          .split(" ")
          .map((n) => n[0])
          .slice(0, 1)
          .join("")}
      </div>
    );
  };

  return (
    <div className="relative w-full mx-auto mb-16" style={{ height: "315px" }}>
      {/* Banner - Sharp edges, primary anchor */}
      <div className="h-[240px] w-full overflow-hidden relative bg-[#05051a]">
        <img
          src="/banner_space.png"
          alt="Cosmic banner"
          className="w-full h-full object-cover"
        />

        {/* Banner overlay for slight darkening */}
        <div className="absolute inset-0 bg-[#000] bg-opacity-[30%] z-0"></div>
      </div>

      {/* Avatar shifted HIGHER into the banner ('konjam mela') */}
      {/* The center of the avatar is physically well above the banner bottom line */}
      <div className="absolute top-[100px] left-12 z-20">
        <div className="w-[190px] h-[190px] rounded-full border-[6px] border-[#fff] overflow-hidden bg-white shrink-0 shadow-sm relative">
          {/* <img
            src="/avatar_woman.png"
            alt="Vishakha Kumar Agrawal"
            className="w-full h-full object-cover"
          /> */}

          <Avatar className="w-full h-full object-cover" />
        </div>
      </div>

      {/* Text block positioned precisely at the SAME height level as the image starting ('top: 100px') */}
      <div className="absolute top-[100px] left-[290px] z-10 w-full pr-12">
        <h1 className="text-[22px] font-bold text-white mb-2 tracking-wide font-sans leading-none profile-header-name">
          {creatorData?.fullName}
        </h1>
        <div
          className="flex items-center space-x-2 text-white text-[15px] pt-1"
          style={{ textShadow: "0 2px 4px rgba(0,0,0,0.9)" }}
        >
          <span className="flex items-center tracking-tight">
            <img src={Follow_icon} alt="Subscriber count" />
            <span className="font-bold text-[20px] mr-1 text-white subscribers-count">
              {creatorData?.subscribersCount || 0}
            </span>{" "}
            <span className="subscribers-label">Subscribers</span>
          </span>
          <span className="flex items-center tracking-tight">
            <span className="font-bold text-[20px] mr-1 text-white subscribers-count">
              {creatorData?.totalPosts || 0}
            </span>{" "}
            <span className="subscribers-label">Post</span>
          </span>
        </div>
      </div>

      {/* About Box - Shifted higher up to maintain the gap, heavily overlapping the banner */}
      <div className="absolute top-[165px] left-[290px] right-12 bg-white px-7 pt-5 pb-6 shadow-[0_2px_15px_rgba(0,0,0,0.06)] rounded-sm border border-[#eef2f6] z-20">
        <h3 className="font-bold text-[16px] text-[#454545] mb-1.5 leading-none f-fam-name-figtree">
          About {creatorData?.fullName}
        </h3>
        <p className="text-[14px] text-[#605F5F] leading-relaxed font-semibold mt-2 f-fam-name-figtree">
          {creatorData?.fullName} is a renowned Vedic astrologer with over 5 years of
          experience. She specializes in relationship readings, career guidance,
          and natal chart analysis. Priya's approach combines traditional
          astrological techniques with modern insights to provide personalized
          guidance and support to her clients.
        </p>
      </div>
    </div>
  );
};

export default ProfileHeader;
